import React, { FC } from 'react';
import translate from '@translate';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { ReloadIcon } from 'src/components/SkladonIcon/Icons';

type TopBlockProps = {
    reloadProvidersList: () => void;
    systems: string[]
    activeTab: string;
    setActiveTab: (value: string) => void;
};
const TopBlock: FC<TopBlockProps> = (props) => {
    const handleChange = (value: string) => {
        props.setActiveTab(value);
    };

    return (
        <>
            <BodyTopBlock
                tabs={props.systems.map(system => ({ value: system, label: system.toUpperCase() }))}
                selectTab={props.activeTab}
                onChangeTab={handleChange}
                actions={[
                    {
                        onClick: props.reloadProvidersList,
                        icon: <ReloadIcon />,
                        tooltip: translate('providers.action.synchronizeTable'),
                        variant: 'outlined'
                    }
                ]}
            />
        </>
    );
};

export default TopBlock;
